import React from 'react'
import { ApprovalQueueContainer } from '@/features/approval/components'

export default function ApprovalQueuePage() {
  return <ApprovalQueueContainer />
}
